import { TrustpilotCarousel } from "./TrustpilotCarousel";

export const UniversalRender = TrustpilotCarousel;
